import {Controller} from '@hotwired/stimulus'
import $ from 'jquery'

export default class extends Controller {
  connect() {
    setTimeout(() => {
      if (this.element.querySelector('.js-frequency-selector'))
        this.frequencyComponent = this.element.querySelector('.js-frequency-selector').parentElement
      this.scheduledDateReactComponent = this.element.querySelector('.js-scheduled-date').closest('[data-react-class]')
      this.statusComponent = this.element.querySelector('.js-status-selector').parentElement
      this.registerEventListeners()
    }, 50)
  }

  handleFrequencyChange() {
    setTimeout(() => {
      const frequency = this.frequencyComponent.querySelector('[type="hidden"]').value
      if (frequency !== 'none') {
        const statuses = JSON.parse(this.statusComponent.dataset.reactProps).options
        const scheduledOption = statuses.find((option) => option.value === 'scheduled')
        const date = new Date()
        if (this.scheduledDateReactComponent)
          this.setComponentProp(this.scheduledDateReactComponent, 'dateString', date.toISOString())
        this.setComponentProp(this.statusComponent, 'defaultValue', scheduledOption)
        this.handleStatusChange()
      }
    }, 50)
  }

  handleStatusChange() {
    setTimeout(() => {
      const status = this.statusComponent.querySelector('[type="hidden"]').value
      $('.dependent-field').not(`.dependent-field.${status}`).slideUp()
      $(`.dependent-field.${status}`).slideDown()
      if (status !== 'scheduled') {
        if (this.element.querySelector('.js-frequency-selector')) {
          const frequencies = JSON.parse(this.frequencyComponent.dataset.reactProps).options
          const noneOption = frequencies.find((option) => option.value === 'none')
          this.setComponentProp(this.frequencyComponent, 'defaultValue', noneOption)
        }
        this.setComponentProp(this.scheduledDateReactComponent, 'dateString', '')
      }
    }, 50)
  }

  registerEventListeners() {
    if (this.element.querySelector('.js-frequency-selector'))
      this.element.querySelector('.js-frequency-selector').addEventListener('change', this.handleFrequencyChange.bind(this))
    this.element.querySelector('.js-status-selector').addEventListener('change', this.handleStatusChange.bind(this))
  }

  setComponentProp(component, prop, value) {
    const props = JSON.parse(component.dataset.reactProps)
    props[prop] = value
    component.dataset.reactProps = JSON.stringify(props)
    ReactRailsUJS.unmountComponents(component.parentElement)
    ReactRailsUJS.mountComponents(component.parentElement)
    this.registerEventListeners()
  }
}
